@if (showPanelChrome()) {
  <proffeo-ui-detail-panel
    (panelClosed)="onPanelClosed()"
    [ariaLabel]="'task-activity-panel.aria-label' | translate"
    [closeAriaLabel]="'task-activity-panel.close' | translate"
    [showClose]="showClose()"
    [showStickyActions]="true"
    [stickyActionsFullWidth]="true"
    class="h-full min-h-0 w-full"
  >
    <h2
      panelTitle
      class="proffeo-ui-detail-panel-title"
    >
      {{ 'task-activity-panel.title' | translate }}
    </h2>

    <div
      panelHeaderActions
      class="flex shrink-0 items-center gap-1"
    >
      <div class="relative inline-flex">
        <proffeo-ui-button
          [matMenuTriggerFor]="activityFilterMenu"
          [ariaLabel]="'task-filters.filters' | translate"
          variant="ghost"
          fontIcon="filter_list"
          class="relative shrink-0"
        />
        @if (selectedFiltersCount() > 0) {
          <span
            class="bg-proffeo-accent pointer-events-none absolute right-0 top-0 z-10 flex h-4 w-4 items-center justify-center rounded-full border border-proffeo-surface text-[10px] text-proffeo-on-action"
          >
            {{ selectedFiltersCount() }}
          </span>
        }
      </div>
    </div>

    <proffeo-task-activities-list
      #activitiesContainer
      [activities]="filteredActivities()"
      class="block min-h-0"
    />

    <proffeo-task-timeline-comment
      (commentSent)="scrollToBottom()"
      [task]="task()"
      panelStickyActions
    />
  </proffeo-ui-detail-panel>
} @else {
  <div class="relative flex flex-col gap-2">
    <div class="flex w-full shrink-0 items-center justify-between">
      <h2 class="m-0 text-xl font-semibold">
        {{ 'task-activity-panel.title' | translate }}
      </h2>
      <div class="relative inline-flex">
        <proffeo-ui-button
          [matMenuTriggerFor]="activityFilterMenu"
          [ariaLabel]="'task-filters.filters' | translate"
          variant="ghost"
          fontIcon="filter_list"
          class="relative shrink-0"
        />
        @if (selectedFiltersCount() > 0) {
          <span
            class="bg-proffeo-accent pointer-events-none absolute right-0 top-0 z-10 flex h-4 w-4 items-center justify-center rounded-full border border-proffeo-surface text-[10px] text-proffeo-on-action"
          >
            {{ selectedFiltersCount() }}
          </span>
        }
      </div>
    </div>

    <proffeo-task-activities-list
      #activitiesContainer
      [activities]="filteredActivities()"
      class="block"
    ></proffeo-task-activities-list>

    <proffeo-task-timeline-comment
      (commentSent)="scrollToBottom()"
      [task]="task()"
      class="shrink-0"
    ></proffeo-task-timeline-comment>
  </div>
}

<mat-menu #activityFilterMenu="matMenu">
  <proffeo-activity-filter-menu [(filters)]="activityFilters"></proffeo-activity-filter-menu>
</mat-menu>
